const MapComponent = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			id="eB4KuDrC9dX1"
			shapeRendering="geometricPrecision"
			textRendering="geometricPrecision"
			viewBox="0 0 262 195"
		>
			<title>Map</title>
			<style>
				{
					'@keyframes eB4KuDrC9dX7_s_do{0%{stroke-dashoffset:393.07}to{stroke-dashoffset:0}}@keyframes eB4KuDrC9dX21_tr__tr{0%{transform:translate(135.33781px,207.03926px) rotate(720deg);animation-timing-function:cubic-bezier(.415,.08,.115,.955)}to{transform:translate(135.33781px,207.03926px) rotate(252.467532deg)}}@keyframes eB4KuDrC9dX21_f_p{0%{fill:#d2dbed}to{fill:#d2dbec}}@keyframes eB4KuDrC9dX22_tr__tr{0%{transform:translate(11.12px,29.9px) rotate(-720deg);animation-timing-function:cubic-bezier(.415,.08,.115,.955)}to{transform:translate(11.12px,29.9px) rotate(-252.467532deg)}}'
				}
			</style>
			<defs>
				<linearGradient
					id="eB4KuDrC9dX15-fill"
					x1={0.5}
					x2={0.5}
					y1={0}
					y2={1}
					gradientUnits="objectBoundingBox"
					spreadMethod="pad"
				>
					<stop
						id="eB4KuDrC9dX15-fill-0"
						offset="0%"
						stopColor="rgba(255,255,255,0)"
					/>
					<stop
						id="eB4KuDrC9dX15-fill-1"
						offset="100%"
						stopColor="#010022"
					/>
				</linearGradient>
			</defs>
			<g clipPath="url(#eB4KuDrC9dX13)">
				<rect width={262} height={195} fill="#004060" rx={12} ry={12} />
				<path
					fill="#2a5f7a"
					d="M268 114.524V34.666l-1.052.258L249.069-36h-36.175l-49.192 12.43L160.567-36h-11.609l23.872 94.69-50.859 12.847-6.389-25.316 22.641-5.718a4.212 4.212 0 0 0 3.056-5.123l-16.827-66.754L142.767-36H114.57l17.482 69.335-18.534 4.686L94.845-36h-19.03l12.58 49.877-17.819 4.507L3.148-36H-6v3.455L30.393-3.18-6 34.626v12.191L37.001 2.142l29.904 24.145a4.186 4.186 0 0 0 3.691.794l19.864-5.004 13.612 53.987L.866 102.134-6 74.913v48.01l3.195-.814 5.318 21.086L-6 145.34v8.716l10.577-2.66 6.35 25.176L-6 204.946V214h4.425l4.068-6.81L4.219 214h8.712l-4.306-17.076 10.457-17.532a4.184 4.184 0 0 0 .457-3.197L5.37 120.044l54.61-13.8 23.098 91.594L75.438 214h9.346l5.735-12.112 42.584-10.761L138.878 214h19.03l-15.637-61.989 50.859-12.846L212.021 214h11.609l-19.566-77.595 27.067-6.83 21.649 12.926 15.22 60.34v-34.588l-6.409-25.415L268 141.21v-8.717l-10.874 2.76-21.65-12.945-14.327-56.767 32.425-8.18L268 114.523ZM90.618 193.152l-22.443-88.973 40.422-10.205 22.443 88.952-40.422 10.226Zm49.589-49.341-13.712-54.364 50.86-12.847 13.711 54.364-50.859 12.847Zm86.459-21.821L202 128.205 188.288 73.84l24.666-6.234 13.712 54.384Zm-42.902-66.06-17.998-71.3 65.305-16.5 17.998 71.32-65.305 16.48Z"
				/>
				<path
					fill="none"
					stroke="#7f9faf"
					strokeWidth={5}
					d="m82 173.5-12.129-49.472L63 96l32.296-7.91L112 84l17.5 67L233 126l-17.5-67 17.5-3.5"
				/>
				<path
					fill="none"
					stroke="#0040ff"
					strokeDasharray={393.07}
					strokeDashoffset={393.07}
					strokeWidth={5}
					d="m82 173.5-12.129-49.472L63 96l32.296-7.91L112 84l17.5 67L233 126l-17.5-67 16.756-3.166"
					style={{
						animation:
							'eB4KuDrC9dX7_s_do 5000ms linear infinite normal forwards',
					}}
				/>
				<path
					fill="#eb4236"
					fillRule="evenodd"
					d="M232.256 56.578c-.42 0-.825-.152-1.14-.428a27.465 27.465 0 0 1-4.223-4.68c-2.043-2.855-2.472-4.956-2.472-6.215 0-4.32 3.515-7.835 7.835-7.835s7.834 3.515 7.834 7.835c0 1.259-.428 3.36-2.471 6.216-1.855 2.592-4.128 4.595-4.223 4.679a1.731 1.731 0 0 1-1.14.428Zm0-13.955c-1.452 0-2.632 1.18-2.632 2.632s1.18 2.632 2.632 2.632c1.451 0 2.632-1.181 2.632-2.632s-1.181-2.632-2.632-2.632Z"
					clipRule="evenodd"
				/>
				<path
					fill="#fff"
					fillRule="evenodd"
					d="M232.256 37.842a7.417 7.417 0 0 0-7.414 7.414c0 1.936 1.055 4.1 2.393 5.97 1.848 2.584 3.664 4.175 4.158 4.608s1.231.433 1.725 0c0 0 2.31-2.024 4.158-4.607 1.338-1.87 2.394-4.035 2.394-5.971a7.417 7.417 0 0 0-7.414-7.414Zm0 10.466a3.054 3.054 0 0 1-3.053-3.052 3.054 3.054 0 0 1 3.053-3.053 3.054 3.054 0 0 1 3.052 3.053 3.054 3.054 0 0 1-3.052 3.052Zm0-11.308c4.552 0 8.255 3.703 8.255 8.256 0 2.393-1.387 4.834-2.55 6.46-1.883 2.632-4.191 4.666-4.288 4.75a2.15 2.15 0 0 1-2.835 0 27.898 27.898 0 0 1-4.287-4.75C225.387 50.09 224 47.65 224 45.257c0-4.553 3.703-8.256 8.256-8.256Z"
					clipRule="evenodd"
				/>
				<path
					fill="#0a84ff"
					d="M92 174c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Z"
				/>
				<path fill="#fff" d="M86 174a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" />
				<circle
					r={9.5}
					fill="none"
					stroke="#fff"
					transform="translate(82 174)"
				/>
				<clipPath id="eB4KuDrC9dX13">
					<rect
						width={262}
						height={195}
						fill="#fff"
						rx={12}
						ry={12}
					/>
				</clipPath>
			</g>
			<rect
				id="eB4KuDrC9dX15"
				width={262}
				height={97.5}
				fill="url(#eB4KuDrC9dX15-fill)"
				strokeWidth={0}
				opacity={0.8}
				rx={0}
				ry={0}
				style={{
					mixBlendMode: 'multiply',
				}}
				transform="translate(0 97.5)"
			/>
		</svg>
	);
};

export default MapComponent;
